import isEqual from 'lodash/isEqual'

import get from 'lodash/get'
import { canLoadMoreitins } from '../../../util/canLoadMoreitins'

import { airSearch } from '../../../services/airSearch'
import { buildFlySearchDisplayFiltersObj } from '../../../util/listingsHelpers'
import { handleError } from '../helpers/handleError/handleError.js'
import {
  updateBrandReference,
  updateDisplayInfiniteScrollLoadMore,
  updateListingsIsLoading,
  updateListingsLoadingMessage,
  updateListingsFetchDataSuccess,
} from '../../../reducers/listings'
import { setListingsMetaData } from '../../../reducers/listingsMetaData/listingsMetaData'
import { toggleLoadingOverlay } from '../../../reducers/uiToggles'
import updateListingsWithCheapestBadge from '@mfs/client/listings-client/actions/listings/fetchData/updateListingsWithCheapestBadge'

/**
 * Load more itineraries and append results to existing table
 */
export function listingsLoadMore(PCLN_BOOTSTRAP_DATA, oldListings, filters) {
  return (dispatch, getState) => {
    const state = getState()
    const activeTabId = state.activeTabId
    const airSearchRequestModel = getState().airSearchRequestModel
    const { defaults: filterDefaults } = getState().filterInfo

    const sortOptions = getState().sortOptions

    // No need to load more
    if (state.listingsHasErrored) {
      return
    }

    dispatch(toggleLoadingOverlay(true)) // Disable loading overlay while loading more
    dispatch(updateListingsIsLoading(true))
    dispatch(updateListingsLoadingMessage('Combining new flight options...'))

    buildFlySearchDisplayFiltersObj({
      filter: filters,
      activeTabId,
      airSearchRequestModel,
      PCLN_BOOTSTRAP_DATA,
    })
    const cguid = PCLN_BOOTSTRAP_DATA?.requestLocals?.webstats?.clientGUID
    const employeeDiscountEnabled = getState().employeeDiscount?.isEnabled
    const standardSessionKey = getState().employeeDiscount?.standardSessionKey
    const employeeSessionKey = getState().employeeDiscount?.employeeSessionKey
    const numOfRenderedListings =
      (getState().listings?.response?.length || 0) +
      (getState().recommendedListings?.[activeTabId]?.length || 0)
    airSearch({
      pclnBootstrapData: PCLN_BOOTSTRAP_DATA,
      fromLoadMore: true,
      sortOptions,
      airSearchRequestModel,
      filterDefaults,
      filterInfo: getState().filterInfo,
      cguid,
      listingsMetaData: getState().listingsMetaData,
      numOfRenderedListings,
      employeeDiscountEnabled,
      standardSessionKey,
      employeeSessionKey,
    })
      .then((res) => {
        const { response } = res

        const {
          requestId,
          lowerBound,
          upperBound,
          filteredCount,
          totalFilteredItineraries,
          selectedPackagePrice,
          minimumRetailPrice,
          minimumListingPrice,
          isProposalPricingMissing,
        } = response.listingsMetaData

        const brandReference = get(response, 'brandReference', [])

        response.listings = updateListingsWithCheapestBadge({ response })

        const listings = oldListings.concat(response.listings)
        const loadMore = canLoadMoreitins(upperBound, totalFilteredItineraries)
        dispatch(updateDisplayInfiniteScrollLoadMore({ loadMore, activeTabId }))
        dispatch(updateListingsIsLoading(false))

        const listingsObj = {
          response: listings,
        }

        /**
         * Some of the meta data that was set on initial request need not be overridden,
         * Override the fields that are necessary
         **/
        const metaData = {
          requestId,
          lowerBound,
          upperBound,
          filteredCount,
          selectedPackagePrice,
          minimumRetailPrice,
          minimumListingPrice,
          isProposalPricingMissing,
        }

        dispatch(setListingsMetaData(metaData))
        dispatch(updateListingsFetchDataSuccess(listingsObj))

        // Update Brand Reference
        if (brandReference?.length && !isEqual(get(getState(), 'brandReference'), brandReference)) {
          dispatch(updateBrandReference(brandReference))
        }
        dispatch(toggleLoadingOverlay(false))
      })
      .catch((error) => {
        window?.newrelic?.noticeError(error)
        handleError({ dispatch, error, requestType: 'LOAD_MORE' })
      })
  }
}
